import { inject, Injectable, signal } from '@angular/core';
import { BrowserPlatformService } from '../../shared/services/browser-platform.service';
import { environment } from '../../../environments/environment';

const STORAGE_KEY = 'cmsProcessOutlookAppointmentChanges';

export function alwaysProcessOutlookAppointments(environmentName: string): boolean {
  return environmentName === 'prod';
}

@Injectable({ providedIn: 'root' })
export class OutlookAppointmentPreferenceService {
  private readonly browser = inject(BrowserPlatformService);
  private readonly alwaysProcess = alwaysProcessOutlookAppointments(environment.name);

  readonly isAvailable = signal(false);
  readonly processChanges = signal(this.alwaysProcess || this.readStoredValue());

  setAvailable(value: boolean): void {
    const isAvailable = value && !this.alwaysProcess;
    this.isAvailable.set(isAvailable);
    this.processChanges.set(this.alwaysProcess || (isAvailable && this.readStoredValue()));
  }

  setProcessChanges(value: boolean): void {
    if (this.alwaysProcess) {
      this.processChanges.set(true);
      return;
    }

    if (!this.isAvailable()) {
      this.processChanges.set(false);
      return;
    }

    this.processChanges.set(value);
    this.writeStoredValue(value);
  }

  toggleProcessChanges(): void {
    this.setProcessChanges(!this.processChanges());
  }

  private readStoredValue(): boolean {
    return this.browser.getLocalStorageItem(STORAGE_KEY) === '1';
  }

  private writeStoredValue(value: boolean): void {
    if (value) {
      this.browser.setLocalStorageItem(STORAGE_KEY, '1');
    } else {
      this.browser.removeLocalStorageItem(STORAGE_KEY);
    }
  }
}
